import AgencyRepository from '../repository/agency.repository'

export default {
  getAgencyList: async function() {
    try {
      const offer = await AgencyRepository.getAgencyList()
      return offer.data
    } catch (error) {
      console.log(error)
    }
  },
}
